<template>
  <!-- <el-dialog title="标签信息"
             :show-close="false"
             :visible.sync="visible"
             width="840px"
             :close-on-click-modal="false"
             append-to-body
             @closed="handleClosed"
             :close-on-press-escape="false"> -->
  <el-drawer custom-class="drawer-custom-class"
             append-to-body
             :close-on-press-escape="false"
             title="标签信息"
             size="880px"
             :visible.sync="visible"
             direction="rtl"
             @closed="handleClosed">
    <div class="drawer-wrap">
      <el-form ref="ruleForm"
               v-loading="loading1"
               class="tag-info-form el-form-item__margin-0"
               label-width="90px">
        <el-form-item label="商品名称:">{{info.productName}}</el-form-item>
        <el-form-item label="批次号:"
                      v-if="info.batchCode">
          <link-route @click.native="linkto">{{info.batchCode}}</link-route>
        </el-form-item>
        <el-form-item label="标签码:"> {{info.tagCode}}</el-form-item>
        <el-form-item label="标签序号:"> {{info.tagNo}} </el-form-item>
        <el-form-item label="二维码:">
          <create-qr-code ref="qr"
                          v-if="visible" />
        </el-form-item>
        <el-form-item label="链接:"> {{info.tagScanUrl}} </el-form-item>
        <el-form-item label="验证码:"
                      v-if="userPermission.OPERATE && info.coatCode"> {{info.coatCode || '-'}} </el-form-item>
        <el-divider>标签流转记录</el-divider>
        <el-table border
                  :data="info.tagTraces">
          <el-table-column label="状态"
                           width="100"
                           prop="phrase">
          </el-table-column>
          <el-table-column label="时间"
                           width="145">
            <template slot-scope="{row}">{{ row.timestamp | dateformat()}}</template>
          </el-table-column>
          <el-table-column label="详情"
                           prop="details">
          </el-table-column>
          <el-table-column label="操作"
                           v-if="userPermission.OPERATE"
                           width="125">
            <template slot-scope="{row}">
              <el-dropdown v-if="row.phraseType === 10">
                <el-button type="text">修改发货对象<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="changedeliverytype(1)">经销商</el-dropdown-item>
                  <el-dropdown-item @click.native="changedeliverytype(2)">终端客户</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-divider>标签扫码记录（{{ list.length}}条）</el-divider>
      <el-button type="danger"
                 v-if="userPermission.OPERATE"
                 style="margin-bottom:10px"
                 :disabled="multipleSelection.length === 0"
                 @click="batchdelete">批量删除（已选{{ multipleSelection.length}}条扫码记录）</el-button>
      <el-table border
                max-height="600px"
                @selection-change="handleSelectionChange"
                v-loading="loading"
                row-key="tagScanId"
                :data="list">
        <el-table-column fixed="left"
                         v-if="userPermission.OPERATE"
                         type="selection"
                         width="40">
        </el-table-column>
        <el-table-column label="扫码时间"
                         width="145">
          <template slot-scope="{row}">{{ row.scanTime | dateformat()}}</template>
        </el-table-column>
        <el-table-column label="扫码地点"
                         prop="address"></el-table-column>
        <el-table-column label="操作"
                         v-if="userPermission.OPERATE"
                         width="60">
          <template slot-scope="{row}">
            <el-button type="text"
                       @click="deletescantag(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
  <!-- <span slot="footer">
      <el-button :loading="loading || loading1"
                 @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog> -->
</template>

<script>
import CreateQrCode from '../public/create-qr-code.vue'
import Tag from '@/service/tag'
export default {
  name: 'tag-search-modal',
  components: { CreateQrCode },
  props: {
    userPermission: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      loading: false,
      loading1: false,
      visible: false,
      info: { tagTraces: [] },
      list: [],
      multipleSelection: []
    }
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    batchdelete () {
      const tagScanId = this.multipleSelection.map(item => item.tagScanId).join(',')
      this.deletescantag({ tagScanId, tagCode: this.info.tagCode })
    },
    deletescantag (row) {
      this.$confirm(`此操作将删除所选的扫码记录，是否继续?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Tag.deletescantag({ tagScanId: row.tagScanId })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList(row.tagCode)
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    changedeliverytype (deliveryType) {
      const txt = `此操作将发货对象切换为【${deliveryType === 1 ? '经销商' : '终端客户'}】是否继续?`
      this.$confirm(txt, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading1 = true
          Tag.changedeliverytype({ deliveryType, tagCode: this.info.tagCode })
            .then(res => {
              const { result, message } = res.data
              this.loading1 = false
              if ([0].includes(result)) {
                this.$message.success('切换成功')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading1 = false
              this.$message.error(err.message)
            })
        })
    },
    linkto () {
      this.visible = false
      this.$router.push(`/batch-detail?vendorId=${this.info.vendorId}&batchId=${this.info.batchId}&productId=${this.info.productId}`)
    },
    handleSelect (tagCode) {
      this.loading1 = true
      this.$store.dispatch('label/gettagprofile', {
        payload: { tagCode },
        success: (res) => {
          this.loading1 = false
          this.info = res.data
          this.visible = true
          setTimeout(() => {
            if (res.data.tagScanUrl) {
              this.$refs.qr.init(res.data.tagScanUrl)
            }
          }, 20)
        },
        fail: () => {
          this.loading1 = false
        }
      })
    },
    fetchList (tagCode) {
      this.loading = true
      this.$store.dispatch('scantag/getscantags', {
        payload: { tagCode },
        success: (res) => {
          this.loading = false
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch (tagCode) {
      this.handleSelect(tagCode)
      this.fetchList(tagCode)
    },
    handleClosed () {
      this.info = { ...this.$options.data().info }
      this.list = []
      this.visible = false
      this.loading = false
      this.loading1 = false
    }
  }
}
</script>
<style lang="stylus" scoped>
/deep/.el-divider__text {
  font-size: 15px;
  font-weight: bold;
  color: #333;
}
</style>
